module.exports = __webpack_public_path__ + "img/pedding_approval.svg";